import { Grid } from "@mui/material";
import FormReception from "./formReception";

export default function EditReceptionModal({ onClose, data, areaId, onEdit }) {
  return (
    <Grid
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      sx={{
        minWidth: "calc(min(100%, 500px))",
        maxWidth: "500px",
        margin: "0 auto",
      }}
    >
      <FormReception
        onEdit={onEdit}
        DATA={data}
        handleClose={onClose}
        ageType={data.ageType}
        areaId={areaId}
      />
    </Grid>
  );
}
